<template>
<div class="manufacturers">

	<div class="page-header">
		<h1><lang labelKey="HEADER_MANUFACTURERS"></lang></h1>
	</div>

	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<template v-if="!isLoading">

				<v-client-table name="tblManufacturers" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblManufacturers noFirstColumn">

					<!-- impersonate this user -->
					<template slot="impersonate" slot-scope="props">
						<impersonate-button :manufacturerId="props.row.id" size="is-small"></impersonate-button>
					</template>

				</v-client-table>

			</template>

		</div>

		<div class="col-aside">

			<affix :offset="50">
				<custom-button type="blue" name="MANUFACTURERS_BTN_MANUFACTURER_ADD" icon="fa icon-ak-hinzufuegen" @click.native="manufacturerAdd"></custom-button>
			</affix>

		</div>

	</div>

</div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

	name: 'manufacturers',

	data() {
		var self = this;
		return {
			isLoading: false,

			table: {
				tblData: [],
				tblColumns: ['extRef', 'name', 'impersonate'],
				tblOptions: {
					saveState: true,
					trackBy: 'extRef',
                    uniqueKey: 'extRef',
					perPage: 25,
					orderBy: {
						ascending: true,
						column: 'name'
					},
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    // custom table headings - make them clickable for language Setting
					headings: {
						extRef(h) {
							return <lang labelKey="SITE_TBL_HEADER-EXTREF"></lang>
						},
						name(h) {
							return <lang labelKey="SITE_TBL_HEADER-NAME"></lang>
						},
						impersonate(h) {
							return <lang labelKey="SITE_TBL_HEADER-IMPERSONATE"></lang>
						},
					},
					sortable: ['extRef', 'name'],
					filterByColumn: true,
					filterable: ['extRef', 'name'],
					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},
					pagination: {
						chunk: 5
					},
					skin: 'table is-striped is-hoverable is-fullwidth',
					rowClassCallback: function(row) {
 						return `row-${row.id}`
					}

				}
			}

		}
	},

	created() {
		this.fetchData();
	},

	mounted() {

	},

	updated() {

		var self = this;
		$("table tbody > tr").unbind("click").on("click", function() {
			var temp = this.className.split("-")[1];
			var id = temp.split(" ")[0];
			// self.$router.push('/einstellungen/hersteller/hersteller-' + id);
			self.$router.push({ name: 'settingsManufacturersEdit', params: { manufacturerID: id } });
		});

	},


	methods: {



		fetchData() {

			this.isLoading = true;
			var self = this;

			// get Mutations
			function getManufacturers() {
				return self.axios.get(self.$config.api + 'manufacturer?orderBy=name');
			}

			// make the request
			this.axios.all([getManufacturers()])

				.then(self.axios.spread(function (manufacturers) {

					self.table.tblData = manufacturers.data.manufacturer;
					self.isLoading = false;

				})).catch(function(error) {

					self.isLoading = false;
					console.log('Error: ', error.message);

				});

		},

		manufacturerAdd() {
			// this.$router.push('/einstellungen/hersteller/neu');
			this.$router.push( { name: 'settingsManufacturersNew' });
		},

	}

}
</script>


<style>
.tblManufacturers th:first-child {
	width: 30%;
}
.tblManufacturers td .imitate {
	width: 220px;
	height: auto;
}
</style>
